import { OnInit, Component, ChangeDetectionStrategy } from '@angular/core';
import { ProjectsTableComponent } from '../../projects-table/projects-table.component';
import Company from '../../../../../model/company/company';

@Component({
  selector: 'abstract-client-projects',
  templateUrl: '../../projects-table/projects-table.component.html',
  styleUrls: ['../../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AbstractClientProjectsComponent extends ProjectsTableComponent
  implements OnInit {
  company: Company;

  newProjectLabel = 'Nieuwe bestelling';

  ngOnInit() {
    super.ngOnInit();

    this.routerLinkOpen = '/klant-opdracht';
    this.company = this.clientCompanySelectService.getSelectedCompany();
    this.reloadData.emit();
    this.addSubscription(
      this.clientCompanySelectService.getSelectionChangedSubscribable(),
      (res: Company) => {
        this.company = res;
        this.reloadData.emit();
      }
    );
  }

  // Override
  protected getTableUrl(): string {
    return (
      '/subprojects/' +
      this.getStatusFilter() +
      '/' +
      (this.company ? this.company.id : -1)
    );
  }

  // Override
  public getRouterLinkNew() {
    return '/client-project/nieuw/0';
  }

  // Override
  public getRouterLinkOpen(isIpBoardProject = false): string {
    return '/klant-opdracht';
  }

  // Override
  public showFromOldSystemButton() {
    return false;
  }
}
